import {ActionTypes, FetchFeaturesFulfilledPayload, FeatureTogglesActionTypes} from './types';
import {FailedRequestPayload} from '../types';

export const fetchFeatureTogglesPending = (payload: FetchFeaturesFulfilledPayload): FeatureTogglesActionTypes => {
  return {
    type: ActionTypes.FETCH_FEATURE_TOGGLES_PENDING,
    payload
  };
};

export const fetchFeatureTogglesFulfilled = (payload: FetchFeaturesFulfilledPayload): FeatureTogglesActionTypes => {
  return {
    type: ActionTypes.FETCH_FEATURE_TOGGLES_FULFILLED,
    payload
  };
};

export const fetchFeatureTogglesRejected = (payload: FailedRequestPayload): FeatureTogglesActionTypes => {
  return {
    type: ActionTypes.FETCH_FEATURE_TOGGLES_REJECTED,
    payload
  };
};
